module.exports = __webpack_public_path__ + "img/san.63e9f161.png";